import { type PromotionPlacement } from '@onr/schema'

export const PROMOTION_SHOP_PLACEMENTS: ReadonlyArray<PromotionPlacement> = [
  'hero',
  'volunteerProfile',
  'volunteerInfo',
  'clientInfo',
  'milestone',
  'email',
]

export type PromotionOptionState = 'available' | 'inPlan' | 'locked'

export interface PromotionOption {
  readonly placement: PromotionPlacement
  readonly state: PromotionOptionState
  readonly fee?: number
  readonly suggestedPrice?: string
}
